export default function ProcessingIcon({ size = 24, color = '#C3C6DB' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7178 20.7081C16.2741 20.7081 19.9678 17.0145 19.9678 12.4581C19.9678 7.90178 16.2741 4.20813 11.7178 4.20813C7.16142 4.20813 3.46777 7.90178 3.46777 12.4581C3.46777 17.0145 7.16142 20.7081 11.7178 20.7081Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.1678 7.50827V12.4583L14.4678 14.1083" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
